export function header() {

    const path = location.pathname;

    const header = document.querySelector('.j-header');
    const header_btn = document.querySelector('.j-header_btn');
    const header_links = document.querySelectorAll('.j-header_link');
    const header_loop = document.querySelector('.l-header_loop');

    header_btn.addEventListener('click', () => {
        if (header.classList.contains('active')) {
            header.classList.remove('active');
            header_loop.classList.remove('active');
        } else {
            header.classList.add('active');
            header_loop.classList.add('active');
        }
    });
    if (window.matchMedia("(max-width: 768px)").matches) {
        [...header_links].forEach((link) => {
            link.addEventListener('click', () => {
                if (header.classList.contains('active')) {
                    header.classList.remove('active');
                    header_loop.classList.remove('active');
                } else {
                    header.classList.add('active');
                    header_loop.classList.add('active');
                }
            });
        });
    }

    // const header = document.querySelector('.j-header');
    const target = document.querySelector('.p-fv_top');

    if (header) {
    let lastScroll = window.scrollY;

    // リロード時に常に表示
    header.classList.add('is-view');

    // スクロールで表示・非表示制御
    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;

        if (currentScroll <= 10 || currentScroll < lastScroll) {
        // 上スクロール または ほぼ最上部
        header.classList.add('is-view');
        } else {
        // 下スクロール
        header.classList.remove('is-view');
        }

        lastScroll = currentScroll;
    });

    // ファーストビュー通過判定
    if (target) {
        const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
            header.classList.add('is-under');
            } else {
            header.classList.remove('is-under');
            }
        },
        {
            root: null,
            threshold: 0,
            rootMargin: `-${header.offsetHeight}px 0px 0px 0px`
        }
        );

        observer.observe(target);
    }
    }


}